export default __webpack_public_path__ + "static/media/bg_gradi_right01.cfcde67b.png";